import React from 'react';
import './App.css';
import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './components/About';
import Garden from './components/Garden';
import Plants from './components/Plants';
import Events from './components/Events';
// import Contact from './components/Contact'; // 暂时隐藏，因为没有对应的轮播分类
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';
import Visit from './components/Visit';
import Learning from './components/Learning';
import NewsDetail from './components/NewsDetail';
import Shop from './components/Shop';
import ProductDetail from './components/ProductDetail';
import GardenMap from './components/GardenMap';
import GardenModuleDetail from './components/GardenModuleDetail';
import MedicinalGarden from './components/MedicinalGarden';
import Laboratory from './components/Laboratory';
import EventDetail from './components/EventDetail';

// 导入缺少的页面组件（暂时使用现有组件代替）
const SupportUs = () => <div className="page-container"><h1>支持我们</h1><p>支持和捐赠信息页面正在建设中...</p></div>;
const Account = () => <div className="page-container"><h1>个人中心</h1><p>用户个人中心页面正在建设中...</p></div>;

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="layout-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/garden" element={<Garden />} />
            <Route path="/garden/map" element={<GardenMap />} />
            <Route path="/garden/module/:moduleId" element={<GardenModuleDetail />} />
            <Route path="/medicinal-garden" element={<MedicinalGarden />} />
            <Route path="/laboratory" element={<Laboratory />} />
            <Route path="/plants" element={<Plants />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/events" element={<Events />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/learning" element={<Learning />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/support-us" element={<SupportUs />} />
            <Route path="/account" element={<Account />} />
            <Route path="/news/:id" element={<NewsDetail />} />

            {/* 暂时隐藏联系我们页面，因为没有对应的轮播分类 */}
            {/* <Route path="/contact" element={<Contact />} /> */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
